const fieldTemplateIconMap = {
  standard: 'font',
  formatted_text: 'font',
  image: 'image',
  video: 'video'
};

export default fieldTemplateIconMap;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/field_template_icon_map.js